import React, { useState } from "react";
import "../../styles/matchstatswidecard.css";

export default function MatchStatsWideCard({ stats }) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="ms-wide-card">


      <div className="ms-stat-title" onClick={() => setIsOpen(!isOpen)} >
        Legfontosabb statisztikák
      </div>


      {isOpen && (
        <>
          <div className="stat-card-border">

            {/* LOGÓK */}
            <div className="ms-stat-logos">
              <img src={`/images/teams/${stats.teams.home.logo}`} alt={stats.teams.home.name} />
              <span>VS</span>
              <img src={`/images/teams/${stats.teams.away.logo}`} alt={stats.teams.away.name} />
            </div>

            {/* STAT SOROK */}
            <div className="ms-stat-list">
              {stats.main.map((stat) => {
                const homeBetter = stat.home_value > stat.away_value;
                const awayBetter = stat.away_value > stat.home_value;

                return (
                  <div className="ms-stat-row" key={stat.stat_key}>

                    <span className={`ms-value ${homeBetter ? "better" : ""}`}>
                      {stat.unit === "%"
                        ? Math.trunc(stat.home_value) + stat.unit
                        : stat.home_value + stat.unit
                      }
                    </span>

                    <span className="ms-label">
                      {stat.label}
                    </span>

                    <span className={`ms-value ${awayBetter ? "better" : ""}`}>
                      {stat.unit === "%"
                        ? Math.trunc(stat.away_value) + stat.unit
                        : stat.away_value + stat.unit
                      }
                    </span>

                  </div>
                );
              })}
            </div>
          </div>

        </>
      )}


    </div>
  );
}